import { ApiService } from "./api.service";
import type { TWorkspaceIntegrationCapabilities } from "@/types/integration-capabilities";

/** What a workspace's connectors can supply (NG-2265). One indexed query server-side,
 *  readable by any member, so it sits well inside the 1s read budget. */
export class IntegrationCapabilityService extends ApiService {
  async getCapabilities(slug: string): Promise<TWorkspaceIntegrationCapabilities> {
    return this.get(`/api/workspaces/${slug}/integrations/capabilities/`);
  }
}
